// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__L57LL","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2a2oU","obliqueLine":"membershipbadge_obliqueLine__2GL2s"};